import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { IncidentsAndTrips } from './components';
import { Grid } from '@material-ui/core';

import { Location } from '@cobliteam/common-types';

import {
  type AppState,
  PopupTypes,
  selectOpenPopup,
  setOpenPopup,
} from '@cobliteam/store';

import { Navbar } from '@cobliteam/base-components';

import HowToUseDropdown from './components/HowToUseDropDown';

const NavbarDashboard = () => {
  const history = useHistory();

  const dispatch = useDispatch();
  const openPopup = useSelector((state: AppState) => selectOpenPopup(state));

  const handleLogoClick = () => {
    history.push('/');
  };

  const getChildren = () => {
    const { pathname } = history.location;

    if (pathname === Location.MONITORING) {
      return (
        <IncidentsAndTrips
          openPopup={openPopup}
          onClickPopup={(popup) => dispatch(setOpenPopup(popup))}
          onClickAway={() => dispatch(setOpenPopup(PopupTypes.NONE))}
        />
      );
    }

    return null;
  };

  return (
    <Navbar onClickLogo={handleLogoClick}>
      <>
        {getChildren()}
        <Grid container alignItems='center' justifyContent='flex-end'>
          <Grid item>
            <HowToUseDropdown />
          </Grid>
        </Grid>
      </>
    </Navbar>
  );
};

export default NavbarDashboard;
